const initialNavigationDrawer = {
  open: true
};

export default  initialNavigationDrawer;